import {ApiService} from "./api.service";

export class UserService extends ApiService {
  constructor() {
    super();
    this.endpoint = "/users";
  }

  async show(id) {
    return super.show(id);
  }

  async signOut() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    return await fetch(`${this.endpoint}/sign_out`, {
      headers: {
        'X-CSRF-Token': token,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: "DELETE",
    });
  }

  // Used for Gift Basket SignIn Modal
  async signIn(params) {

    //Grab the form data from params (sign in modal)
    const formData = new FormData();
    formData.append('user[email]', params.user.email);
    formData.append('user[password]', params.user.password);
    formData.append('user[remember_me]', params.user.remember_me || false);

    //this fetch connects to Devise
    return await fetch(`/users/sign_in`, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: "POST",
      body: formData
    });
  }

  // async rememberMe() {
  //   return false;
  // }


  update(id, params) {
    return super.update(id, params);
  }

  async changePassword(userId, newPassword) {
    const params = {
      user: {
        password: newPassword,
        password_confirmation: newPassword
      }
    };
    return this.patch(`${this.endpoint}/${userId}/change_password`, params);
  }

  async getPermittedOrgs(userId, params) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/permitted_organizations`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async getDonorOrgs(userId, params) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/donor_organizations`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async getDonorProfile(userId, params) {
    try {
      let respose = await this.get(`${this.endpoint}/${userId}/donor_profile`, params);
      return respose.json;
    } catch {
      return {};
    }
  }

  async getUserDonations(userId, params) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/donations`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async getUserDonationYears(userId, params) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/donation_years`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async getUserSubscriptions(userId, params) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/subscriptions`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async resendInvitationEmail(userId) {
    try {
      let response = await this.get(`${this.endpoint}/${userId}/resend_email_invitation`);
      return response.json;
    } catch {
      return {};
    }
  }

  stopImpersonation() {
    return this.get(`${this.endpoint}/stop_impersonating`);
  }

}
